import { AreaUnit } from '../../graphql/graphql';

export const MIN_ANNUAL_AREA_AMOUNTS = {
  [AreaUnit.Acres]: 250,
  [AreaUnit.Hectares]: 100,
} as Record<AreaUnit, number>;

export const MAX_AREA_AMOUNTS = {
  [AreaUnit.Acres]: 25000,
  [AreaUnit.Hectares]: 10000,
} as Record<AreaUnit, number>;

export const DEFAULT_MONTHLY_AREA_AMOUNTS = {
  [AreaUnit.Acres]: 1000,
  [AreaUnit.Hectares]: 400,
} as Record<AreaUnit, number>;
